import { Navigate, useLocation, useParams } from 'react-router'

export function LegacyPackagingSuppliersListRedirect() {
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const view = params.get('view')
  if (view === 'packed-items') {
    return <Navigate to='/packaging/packed-items' replace />
  }
  return <Navigate to='/packaging/suppliers' replace />
}

export function LegacyPackagingSupplierDetailRedirect() {
  const { packagingSupplierId = '' } = useParams<{ packagingSupplierId: string }>()
  return (
    <Navigate to={`/packaging/suppliers/${packagingSupplierId}`} replace />
  )
}

export function LegacyPackagingItemDetailRedirect() {
  const { packagingSupplierId = '', itemId = '' } = useParams<{
    packagingSupplierId: string
    itemId: string
  }>()
  return (
    <Navigate
      to={`/packaging/suppliers/${packagingSupplierId}/items/${itemId}`}
      replace
    />
  )
}
